<template>
	<div :class="['c-content', size]">
		<slot />
	</div>
</template>

<script setup lang="ts">
const {
	size = 'md',
} = defineProps<{
	size?: 'sm' | 'md' | 'lg' | 'xl';
}>();
</script>

<style scoped lang="postcss">
.c-content {
    & :deep() {
        h1, h2, h3, h4, h5, h6 {
            @apply font-bold font-display;
        }

        h1 {
            @apply text-title-size-2xl sm:text-title-size-3xl;
        }

        h2 {
            @apply text-title-size-xl sm:text-title-size-2xl;
        }

        h3 {
            @apply text-title-size-lg sm:text-title-size-xl;
        }

        h4 {
            @apply text-title-size-md sm:text-title-size-lg;
        }

        h5 {
            @apply text-title-size-sm sm:text-title-size-md;
        }

        h6 {
            @apply text-title-size-sm;
        }

        p,
        li {
            > a {
                @apply underline underline-offset-2;
            }
        }

        p > a {
            @apply decoration-dotted;
        }

        li > a {
            @apply text-purple-600;
        }

        ul,
        ol {
            @apply pl-12;

            &.list-none {
                @apply pl-0;

                > li {
                    @apply pl-0;
                }
            }

            > li {
                @apply pl-4 py-1 first:pt-0 last:pb-0;
            }
        }

        ul {
            @apply list-disc text-paragraph-size-md marker:text-brand-500 mb-3;
        }

        ol {
            @apply list-decimal text-paragraph-size-md marker:text-brand-500;
        }
    }

    &.sm :deep() {
        @apply text-paragraph-size-sm;

        h1, h2, h3, h4, h5, h6 {
            @apply pt-4;
        }

        > * {
            @apply mb-6;
        }

    }

    &.md :deep() {
        @apply text-paragraph-size-md;

        h1, h2, h3, h4, h5, h6 {
            @apply pt-8;
        }

        > * {
            @apply mb-8;
        }
    }

    &.lg :deep() {
        @apply text-paragraph-size-lg;

        h1, h2, h3, h4, h5, h6 {
            @apply pt-10;
        }

        > * {
            @apply mb-12;
        }
    }

    &.xl :deep() {
        @apply text-paragraph-size-xl;

        h1, h2, h3, h4, h5, h6 {
            @apply pt-12;
        }

        > * {
            @apply mb-16;
        }
    }
}
</style>
